import containsEmoji from "./containsEmoji";

const validateEmailWithEmoji = function (email) {
    const hasEmoji = containsEmoji(email);
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email) && !hasEmoji;
};
export default validateEmailWithEmoji;
